import { enqueueSnackbar } from 'notistack';
import { addVendorApi, listVendorsApi } from 'api/inventory';
import { vendorManagementActions } from 'store/slices/vendorManagementSlice';
import { handleError } from './errorHandlerThunks';

export const listVendorsByPage =
  ({ page }) =>
  (dispatch, getState) => {
    const { sort, filter } = getState().inventory.vendorManagement;
    dispatch(vendorManagementActions.updateCurrentPage(page));
    return listVendorsApi({ vendor: filter.vendor, sort, page })
      .then(({ items, totalCount }) =>
        dispatch(vendorManagementActions.loadVendors({ page, items, totalCount }))
      )
      .catch((error) => dispatch(handleError({ error })));
  };

export const filterVendors =
  ({ filter }) =>
  (dispatch) => {
    dispatch(vendorManagementActions.updateFilter(filter));
    dispatch(listVendorsByPage({ page: 1 }));
  };

export const updateVendorSort =
  ({ sort }) =>
  (dispatch) => {
    dispatch(vendorManagementActions.setSort(sort));
    dispatch(listVendorsByPage({ page: 1 }));
  };

export const addVendor =
  ({ vendor, onSuccess, onDuplicate }) =>
  (dispatch) =>
    addVendorApi(vendor)
      .then((newVendor) => {
        enqueueSnackbar('Vendor added successfully', { variant: 'success' });
        dispatch(listVendorsByPage({ page: 1 }));
        onSuccess?.(newVendor);
      })
      .catch((error) => {
        const errorCode = error.response?.errors?.[0]?.extensions?.code;
        if (errorCode === 'VENDOR_ALREADY_EXISTS') {
          onDuplicate?.();
        } else {
          dispatch(handleError({ error }));
        }
      });
